import { app } from '../../../../../app';
import { Controller } from './approval-policy.controller';

app.component('companyManageApplicationApprovalPolicy', {
    bindings: {
        application: '<',
        companyId: '<',
        approvalPolicyList: '<',
    },
    controller: Controller,
    templateUrl: require('./approval-policy.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/approval-policy/approval-policy.component.js